module.exports = __webpack_public_path__ + "img/pexels-maryia-plashchynskaya-3393793.5002b01f.jpg";